module.exports = __webpack_public_path__ + "static/media/software.25ff7a12.png";